export default "__VITE_ASSET__DRtAJNUu__"